import { render, staticRenderFns } from "./__PermissionModal.vue?vue&type=template&id=bb8532ec&"
import script from "./__PermissionModal.vue?vue&type=script&lang=js&"
export * from "./__PermissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports